import React from 'react'

const pagination = ({ dataPerPage, totalData, curPage, paginate, pageLen }) => {

    const pageNumbers = []
    const indexOfLastData = curPage * dataPerPage
    const indexOfFirstData = (indexOfLastData - dataPerPage)+1

    for (let index = 1; index <= Math.ceil(totalData / dataPerPage); index++) {
        pageNumbers.push(index)
    }

    const next = (pg) => {
        if (curPage < Math.ceil(totalData / dataPerPage)) {
            paginate(pg)
        }
    }

    const prev = (pg) => {
        if (pg > 0) {
            paginate(pg)
        }
    }

    return (
        <>
            <div className="row mt-5">
                <div className="col-md-6 ps-md-0 ps-2">
                    {"Showing result "+indexOfFirstData+" - "+((indexOfFirstData+pageLen)-1)+" of "+totalData}
                </div>
                <div className="col-md-6 mt-md-0 mt-2">
                    <nav>
                        {/* {curPage} */}
                        <ul className="pagination float-md-end">
                            <button onClick={() => prev(curPage-1)} className='btn btn-basic'>Previous</button>
                            {pageNumbers.map(number => 
                                <li key={number} className="page-item">
                                    <button onClick={() => paginate(number)} className={ curPage === number ? "page-link" : "btn btn-basic"}>{number}</button>
                                </li>
                        )}  
                        <button onClick={() => next(curPage+1)} className='btn btn-basic'>Next</button>
                        </ul>  
                    </nav>
                </div>
            </div>
        </>
    )
}

export default pagination
